import React from "react";
import { supabase } from "../supabaseClient";
import { buildAuthRedirect } from "../utils/authRedirect";
import { FaGoogle, FaFacebook, FaApple } from "react-icons/fa";

export default function LoginSocial({ setNotification, redirectOnSuccess }) {
  // URL para onde o Supabase redireciona após OAuth.
  // O AuthListener global cuida de redirecionar para o destino correto após o login.
  const REDIRECT_URL = buildAuthRedirect(redirectOnSuccess || "/");

  const handleOAuthSignIn = async (provider) => {
    try {
      // O signInWithOAuth faz o trabalho de redirecionar o usuário para a página
      // do provedor (Google, FB, Apple) e volta para o REDIRECT_URL.
      const { error } = await supabase.auth.signInWithOAuth({
        provider: provider, // 'google', 'facebook', 'apple'
        options: {
          redirectTo: REDIRECT_URL,
        },
      });

      if (error) {
        console.error(`Erro no Login Social (${provider}):`, error.message);
        if (setNotification) {
          setNotification({
            show: true,
            message: `Falha ao tentar logar com ${provider}. Verifique as configurações do Supabase.`,
            type: "error",
          });
        }
      }
      // Se for bem-sucedido, o navegador será redirecionado para o provedor.
    } catch (err) {
      console.error("Erro inesperado durante o Login Social:", err);
    }
  };

  return (
    <div className="mb-1 flex items-center justify-center gap-3">
      <button
        type="button"
        data-cy="oauth-google-button"
        onClick={() => handleOAuthSignIn("google")}
        aria-label="Entrar com Google"
        title="Entrar com Google"
        className="group inline-flex h-12 w-12 items-center justify-center rounded-full border border-warm-200 bg-white text-[#3a2f2b] shadow-sm transition-all duration-150 hover:-translate-y-0.5 hover:border-rose-300 hover:bg-rose-50 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-300/60 active:translate-y-0 active:scale-95"
      >
        <FaGoogle className="text-[1.18rem] transition-transform duration-150 group-hover:scale-110" />
      </button>

      <button
        type="button"
        data-cy="oauth-facebook-button"
        onClick={() => handleOAuthSignIn("facebook")}
        aria-label="Entrar com Facebook"
        title="Entrar com Facebook"
        className="group inline-flex h-12 w-12 items-center justify-center rounded-full border border-warm-200 bg-white text-[#3a2f2b] shadow-sm transition-all duration-150 hover:-translate-y-0.5 hover:border-rose-300 hover:bg-rose-50 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-300/60 active:translate-y-0 active:scale-95"
      >
        <FaFacebook className="text-[1.18rem] transition-transform duration-150 group-hover:scale-110" />
      </button>

      <button
        type="button"
        data-cy="oauth-apple-button"
        onClick={() => handleOAuthSignIn("apple")}
        aria-label="Entrar com Apple"
        title="Entrar com Apple"
        className="group inline-flex h-12 w-12 items-center justify-center rounded-full border border-warm-200 bg-white text-[#3a2f2b] shadow-sm transition-all duration-150 hover:-translate-y-0.5 hover:border-rose-300 hover:bg-rose-50 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-300/60 active:translate-y-0 active:scale-95"
      >
        <FaApple className="text-[1.18rem] transition-transform duration-150 group-hover:scale-110" />
      </button>
    </div>
  );
}
